import { render, staticRenderFns } from "./SalesWidget.vue?vue&type=template&id=5a6a55a2&scoped=true"
import script from "./SalesWidget.vue?vue&type=script&lang=js"
export * from "./SalesWidget.vue?vue&type=script&lang=js"
import style0 from "./SalesWidget.vue?vue&type=style&index=0&id=5a6a55a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6a55a2",
  null
  
)

export default component.exports